/**
 * Der Zusammenbau der Bestellliste aus den Rohdaten: JTL-Zeilen mit den Hub-Zeilen zusammenfuehren
 * (`lib/jtlZusammenfuehren.ts`), danach den Board-Status normalisieren (`index.html:5831-5835`,
 * `state/statusNormalisierung.ts`) gegen die Spalten der Board-Konfiguration.
 *
 * Bis zum KI-Zugang (Stufe 1) stand diese Folge zweimal ausgeschrieben in `state/Speicher.tsx` (voller
 * Lauf `bestandLaden`, Teillauf `bestandTeilLaden`). Sie ist EINE Funktion geworden, weil der Server
 * (`backend/src/ki/auswertung/frontend/`) denselben Zusammenbau fahren muss wie die Oberflaeche und
 * dafuer eine zeichengleiche Kopie dieses Moduls braucht. Die Reihenfolge ist die Aussage: erst
 * zusammenfuehren, DANN normalisieren - `zusammenfuehren` kennt die Board-Spalten nicht, und der
 * Rueckfall des Status ist die ERSTE Spalte (siehe Kommentar in `Speicher.tsx#bestandLaden`).
 *
 * Regel fuer dieses Modul (`test/lib/reineKette.test.ts`): nur `.ts`-Importe innerhalb von
 * `frontend/src`, kein `react`, kein `import.meta`, keine Browser-Globals.
 */
import { jtlBestellungenZusammenfuehren } from "./jtlZusammenfuehren.ts";
import type { JtlBestellungRoh, JtlLoeschFelder } from "./jtlZusammenfuehren.ts";
import { setStatusDefinitions } from "./status.ts";
import type { BoardColumnLike } from "./status.ts";
import type { Order } from "./types.ts";
import { normalisierteStatus } from "../state/statusNormalisierung.ts";

/**
 * `normalisierteStatus(jtlBestellungenZusammenfuehren(jtlRoh, hubZeilen), setStatusDefinitions(boardSpalten))`.
 * Unveraenderte Bestellungen kommen als dieselbe Referenz zurueck (siehe `normalisierteStatus`).
 */
export function bestellungenZusammensetzen(
  jtlRoh: readonly JtlBestellungRoh[],
  hubZeilen: readonly Order[],
  boardSpalten: readonly BoardColumnLike[],
): Array<Order & JtlLoeschFelder> {
  return normalisierteStatus(
    jtlBestellungenZusammenfuehren(jtlRoh, hubZeilen),
    setStatusDefinitions(boardSpalten),
  );
}
